import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  @Input() cardType: string = '';
  @Input() id!: number;
  @Input() title: string = 'Card Title';
  @Input() content: string = 'Card Description';
  @Input() imgSrc: string = '';
  @Input() imgAlt: string = '';
  @Input() videoSrc: string = '';
  @Input() videoType: string = '';

  @Output() cardClickedAction: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  emitCardClicked(card: any) {
    this.cardClickedAction.emit(card);
  }
}
